module.exports = __webpack_public_path__ + "img/faq3.4f7a0732.png";